import { render, staticRenderFns } from "./ModalCambiarPropietario.vue?vue&type=template&id=5af19490&scoped=true"
import script from "./ModalCambiarPropietario.vue?vue&type=script&lang=js"
export * from "./ModalCambiarPropietario.vue?vue&type=script&lang=js"
import style0 from "./ModalCambiarPropietario.vue?vue&type=style&index=0&id=5af19490&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af19490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af19490')) {
      api.createRecord('5af19490', component.options)
    } else {
      api.reload('5af19490', component.options)
    }
    module.hot.accept("./ModalCambiarPropietario.vue?vue&type=template&id=5af19490&scoped=true", function () {
      api.rerender('5af19490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/permisos/ModalCambiarPropietario.vue"
export default component.exports